import React, { useState, useRef } from "react";
import { motion, AnimatePresence, useInView } from "framer-motion";
import "./OurMissionSection.css";

const questionsData = [
  {
    id: 1,
    question: "Which ASIC design flows do you support?",
    answer:
      "Our ASIC design services cover everything from system architecture and RTL coding in SystemVerilog through synthesis and place-and-route. We leverage industry-leading EDA tools to optimize for power, performance, and area.",
  },
  {
    id: 2,
    question: "How do you ensure design correctness?",
    answer:
      "We employ advanced verification methodologies—UVM-based testbenches, formal property checking, and coverage-driven regression—to uncover and eliminate bugs before silicon tape-out.",
  },
  {
    id: 3,
    question: "What low-power techniques do you use?",
    answer:
      "Our team implements clock-gating, power-gating, multi-voltage domains and dynamic voltage/frequency scaling to meet stringent power budgets without compromising performance.",
  },
];

const OurMissionSection = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, {
    margin: "-100px 0px -100px 0px",
    once: false,
  });
  const [expandedId, setExpandedId] = useState(null);
  const toggleAccordion = (id) => {
    setExpandedId((prev) => (prev === id ? null : id));
  };

  return (
    <section
      ref={sectionRef}
      className="our-mission-about-us-section"
    >
      <motion.div
        className="our-mission-about-us-content"
        initial={{ opacity: 0 }}
        animate={{ opacity: isInView ? 1 : 0 }}
        transition={{ duration: 0.7 }}
      >
        <div className="our-mission-header">
          <span className="section-label">Our mission</span>
          <h2 className="mission-title">
            Delivering Best-in-Class ASIC Design &amp; Verification
          </h2>
        </div>

        <div className="our-mission-questions">
          {questionsData.map((item) => {
            const isExpanded = expandedId === item.id;
            return (
              <div key={item.id} className="question-item">
                <button
                  className="question-toggle"
                  onClick={() => toggleAccordion(item.id)}
                >
                  <span className="question-index">
                    {item.id < 10 ? `0${item.id}.` : `${item.id}.`}
                  </span>
                  <span className="question-text">{item.question}</span>
                  <span className="arrow-icon">
                    {isExpanded ? "▴" : "▾"}
                  </span>
                </button>

                <AnimatePresence initial={false}>
                  {isExpanded && (
                    <motion.div
                      className="answer-wrapper"
                      key="content"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                    >
                      <div className="answer-text">
                        {item.answer}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </motion.div>
    </section>
  );
};

export default OurMissionSection;